import Head from 'next/head';
import { useRouter } from 'next/router';
import { useFormat } from 'helpers/hooks/useFormat';
import { FEATURE_FLAG_LIST, useFeatureFlags } from 'hooks';
import { useAccount } from 'frontastic/index';

type Props = {
  title: { [key: string]: string } | string | undefined;
  description?: { [key: string]: string } | string | undefined;
};

export const MetaTitle = ({ title, description }: Props) => {
  const { locale } = useRouter() ?? '';
  const { account } = useAccount();
  const { isFeatureEnabled } = useFeatureFlags();

  const { formatMessage } = useFormat({ name: 'common' });

  const isDynamicCountryEnabled = isFeatureEnabled(FEATURE_FLAG_LIST.DYNAMIC_META_TITLE_COUNTRY);

  const countryLabel = isDynamicCountryEnabled ? account?.companyProfile?.partnerCountry ?? '' : 'CA/US';

  // If title is not added in studio, it is coming as empty array ('[]'). Adding title from language json file as fallback.
  let pageTitle =
    Array.isArray(title) || !title
      ? formatMessage({ id: 'meta.title' })
      : typeof title === 'object'
      ? locale && title[locale]
      : title;

  pageTitle += ` | lululemon ${countryLabel}`;

  const pageContent =
    Array.isArray(description) || !description
      ? formatMessage({ id: 'meta.desc' })
      : typeof description === 'object'
      ? locale && description[locale]
      : description;

  return (
    <Head>
      <title data-testid="title__page-title_test-id">{pageTitle}</title>
      <meta name="description" content={pageContent} />
    </Head>
  );
};
